import type { LoggerConfig, LogLevel, SentryLike, ElasticLike } from './types'
import { getDefaultLevel } from './levels'

interface LoggerState {
  sentry?: SentryLike
  elastic?: ElasticLike
  provider: string
  stage: string
  level: LogLevel
  version?: string
  maskPII: boolean
  initialized: boolean
}

const state: LoggerState = {
  provider: 'unknown',
  stage: process.env.DEPLOYMENT_STAGE || process.env.NODE_ENV || 'local',
  level: getDefaultLevel(),
  maskPII: true,
  initialized: false
}

let warnedNoInit = false

export function initState(config: LoggerConfig): void {
  state.sentry = config.sentry
  state.elastic = config.elastic
  state.provider = config.provider || 'unknown'
  state.stage = config.stage || process.env.DEPLOYMENT_STAGE || process.env.NODE_ENV || 'local'
  state.level = config.defaultLevel || getDefaultLevel()
  state.version = config.version
  state.maskPII = config.maskPII ?? true
  state.initialized = true
}

export function getState(): Readonly<LoggerState> {
  if (!state.initialized && !warnedNoInit && process.env.NODE_ENV === 'development') {
    warnedNoInit = true
    console.warn('[@paintscout/logger] createLogger() called before initLogger(). Sentry and ES features are disabled.')
  }
  return state
}

export function resetState(): void {
  state.sentry = undefined
  state.elastic = undefined
  state.provider = 'unknown'
  state.stage = process.env.DEPLOYMENT_STAGE || process.env.NODE_ENV || 'local'
  state.level = getDefaultLevel()
  state.version = undefined
  state.maskPII = true
  state.initialized = false
  warnedNoInit = false
}
